import React from 'react';
import CompanyCard from './CompanyCard';
import { USE_V2_DESIGN } from '@rd-web-markets/market/dist/constants';
const CompanyList = _ref => {
  let {
    models,
    accountType,
    refreshCompanies,
    CompanyCardActionButtons,
    CompanyCardHeader,
    deleteCompanyGroup,
    setLoading,
    type = 'company'
  } = _ref;
  const to = companyId => {
    if (type === 'company') {
      return USE_V2_DESIGN ? "/".concat(accountType, "/companies/").concat(companyId, "/overview") : "/".concat(accountType, "/companies/").concat(companyId, "/master");
    } else {
      return "/".concat(accountType, "/company_groups/").concat(companyId, "/");
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "company-cards-container"
  }, models.map(model => {
    return /*#__PURE__*/React.createElement(CompanyCard, {
      key: model.id,
      model: model,
      deleteCompanyGroup: deleteCompanyGroup,
      accountType: accountType,
      refreshCompanies: refreshCompanies,
      CompanyCardHeader: CompanyCardHeader,
      CompanyCardActionButtons: CompanyCardActionButtons,
      setLoading: setLoading,
      to: to(model.id),
      type: type
    });
  }));
};
export default CompanyList;